<template>
  <section id="partners" class="h25-section">
    <div class="h25-container">
      <div class="h25-sec-hd center">
        <div class="label">Partners</div><h2>生态合作伙伴</h2>
        <p>创势联合商协会、行业咨询公司、各区域运营商等生态渠道伙伴，整合本地化资源与AI技术能力，共同面向终端客户输出一体化服务</p>
      </div>
      <div class="partner-grid">
        <div class="partner-card" v-for="p in partners" :key="p.icon">
          <div class="icon">{{ p.icon }}</div><h4>{{ p.title }}</h4><p>{{ p.desc }}</p>
        </div>
      </div>
      <div class="partner-cta">
        <h4>零门槛启动</h4>
        <p>填写意向表（2分钟）→ 方案对齐会（30分钟线上）→ 签署协议，进入试合作</p>
        <span class="h25-btn-primary" @click="goAnchor('contact')">立即预约合作咨询 →</span>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name:'PartnersSection',
  inject:['goAnchor'],
  data(){return{partners:[
    {icon:'🏛️',title:'商协会组织',desc:'获得可落地的AI产品库+会员增值方案，销售分成+年费变现，将号召力转化为可持续收入。'},
    {icon:'🏢',title:'区域运营商/集成商',desc:'获得政务级AI产品授权+联合投标资格+本地化培训，项目分成+代理折扣，提升客单价与中标率。'},
    {icon:'📊',title:'行业咨询公司',desc:'全套技术交付能力由我们承担，你专注咨询即可。技术分包+运维分成，零技术团队交付大型项目。'},
    {icon:'💬',title:'SaaS/企微服务商',desc:'开放政务AI的API/SDK快速集成，按调用量/订阅分成结算，零研发成本扩充产品线。'}
  ]}}
}
</script>
<style scoped>
.partner-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:14px}
.partner-card{text-align:center;padding:28px 14px;background:var(--h25-white);border:1px solid var(--h25-border);border-radius:var(--h25-radius);transition:border-color .2s}
.partner-card:hover{border-color:var(--h25-muted2)}
.icon{font-size:28px;margin-bottom:10px}
h4{font-size:14px;font-weight:700;color:var(--h25-text);margin-bottom:4px}
.partner-card p{font-size:12px;color:var(--h25-muted)}
.partner-cta{text-align:center;margin-top:44px;padding:32px 24px;background:var(--h25-white);border:1px solid var(--h25-border);border-radius:var(--h25-radius)}
.partner-cta h4{font-size:17px;font-weight:700;color:var(--h25-text);margin-bottom:8px}
.partner-cta p{font-size:14px;color:var(--h25-muted);margin-bottom:20px;line-height:1.8}
@media(max-width:768px){.partner-grid{grid-template-columns:repeat(2,1fr)}}
</style>
